function YourProfileIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#7953D2" fillOpacity="0.2" />
      <path
        d="M6.6665 15.9987C6.6665 15.2915 6.94746 14.6132 7.44755 14.1131C7.94765 13.613 8.62593 13.332 9.33317 13.332H14.6665C15.3737 13.332 16.052 13.613 16.5521 14.1131C17.0522 14.6132 17.3332 15.2915 17.3332 15.9987C17.3332 16.3523 17.1927 16.6915 16.9426 16.9415C16.6926 17.1916 16.3535 17.332 15.9998 17.332H7.99984C7.64622 17.332 7.30708 17.1916 7.05703 16.9415C6.80698 16.6915 6.6665 16.3523 6.6665 15.9987Z"
        stroke="#492897"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.666C13.1046 10.666 14 9.77059 14 8.66602C14 7.56145 13.1046 6.66602 12 6.66602C10.8954 6.66602 10 7.56145 10 8.66602C10 9.77059 10.8954 10.666 12 10.666Z"
        stroke="#492897"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default YourProfileIcon;
